import { render, staticRenderFns } from "./AreaBasicMulti.vue?vue&type=template&id=4c00df6a&scoped=true&"
import script from "./AreaBasicMulti.vue?vue&type=script&lang=js&"
export * from "./AreaBasicMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c00df6a",
  null
  
)

export default component.exports